module.exports = __webpack_public_path__ + "img/camille-couvez.39cdb4aa.jpg";